export interface JetCardMarginWindow {
  totalTrips?: number;
  avgMargin?: number | null;
}

export interface CharterMarginWindow {
  quotedTrips?: number;
  takenTrips?: number;
  cvr?: number | null;
  avgMargin?: number | null;
}

export const formatMarginCompact = (margin: number | null | undefined): string => {
  // the payload arrives through a cast, so a non-number can reach this and `.toFixed` would throw
  if (typeof margin !== 'number' || Number.isNaN(margin)) {
    return '0%';
  }
  return `${Number(margin.toFixed(1))}%`;
};

// 'Total Trips | Avg Margin'
export const jetCardMarginValue = (marginWindow?: JetCardMarginWindow | null): string =>
  `${marginWindow?.totalTrips ?? 0} Trips | ${formatMarginCompact(marginWindow?.avgMargin)}`;

// 'Trips Quoted/Taken | CVR | Avg Margin'
export const charterMarginValue = (marginWindow?: CharterMarginWindow | null): string =>
  `${marginWindow?.quotedTrips ?? 0}/${marginWindow?.takenTrips ?? 0} Trips`
  + ` | ${formatMarginCompact(marginWindow?.cvr)}`
  + ` | ${formatMarginCompact(marginWindow?.avgMargin)}`;
